import { Route, Switch, Redirect } from 'react-router-dom'

import SignIn from '../../../pages/Auth/SignIn'
import SignUp from '../../../pages/Auth/SignUp'
import NewPass from '../../../pages/Auth/NewPass'
import Confirm from '../../../pages/Auth/Confirm'
import ExpertConfirm from '../../../pages/Auth/ExpertConfirm'
import RecoverPass from '../../../pages/Auth/RecoverPass'

import PublicMenu from '../../../components/PublicMenu'
import PublicFooter from '../../../components/PublicFooter'

import { TRoutes } from '../../../shared/const'

import styles from './style.module.scss'

/**
 * Rahmen aller Anmeldeseiten: das Banner links, die Seite rechts.
 *
 * **Kopf und Fußzeile stehen seit 31.08.2026 hier, nicht mehr in den Seiten.**
 * Davor trug jede der elf Anmeldeansichten eine eigene Zeile oben rechts
 * (`UI/policyLinks`): die zwei Chips, die vier Rechtsverweise und „Powered by
 * DaVinciLab" nebeneinander über dem Formular. Die Rechtsverweise gehören
 * dorthin, wo sie auf jeder anderen Seite stehen — ans Ende, in dieselbe
 * Fußzeile (`components/PublicFooter`). Damit führt „Powered by DaVinciLab"
 * auch hier auf `/davincilab` statt nach draußen.
 *
 * Oben bleiben die Chips: Wer ohne Konto auf der Anmeldeseite landet, braucht
 * den Weg zurück zu den Junior Companies sofort und nicht am Seitenende.
 */
export default function Auth() {
	return (
		<div className={styles.root}>
			<div className={styles.banner} />

			{/*
			 * Die Spalte ist mindestens fensterhoch und die Fußzeile ihr letztes
			 * Kind — so sitzt sie am unteren Rand, auch wenn eine kurze Seite
			 * (etwa die Passwortabfrage) den Platz nicht füllt.
			 */}
			<div className={styles.spalte}>
				<PublicMenu alsChips className={styles.menu} />

				<div className={styles.inhalt}>
					<Switch>
						<Route path={TRoutes.SIGN_IN} component={SignIn} exact />
						<Route path={TRoutes.SIGN_UP} component={SignUp} exact />

						<Route path={TRoutes.RECOVER_PASS} component={RecoverPass} exact />
						<Route path={TRoutes.NEW_PASS} component={NewPass} exact />
						<Route path={TRoutes.NEW_PASS_NEW_USER} component={NewPass} exact />

						<Route path={TRoutes.AUTH_CONFIRM} component={Confirm} exact />
						<Route path={TRoutes.EXPERT_CONFIRM} component={ExpertConfirm} exact />

						<Redirect to={TRoutes.SIGN_IN} exact />
					</Switch>
				</div>

				<PublicFooter />
			</div>
		</div>
	)
}
